
import { Quest, QuestCategory } from '../../../types';

export const RUBE_GOLDBERG_QUESTS: Quest[] = [
  { 
    id: 1300, 
    category: QuestCategory.Creator, 
    title: 'The Spark of Invention', 
    questlineId: 'rube-goldberg', 
    isQuestlineStart: true, 
    description: 'Let\'s start a long-term engineering project! Your first mission is to learn about Rube Goldberg machines and get inspired.', 
    details: 'Watch a few videos of amazing Rube Goldberg machines. In your lined notebook, start an "Invention Log". Your first entry: three ideas for a "final task" your machine could accomplish, like "turn on a light" or "feed a pet a treat".',
    youtubeId: 'gv_sYpXbCiQ'
  },
  { 
    id: 1301, 
    category: QuestCategory.Creator, 
    title: 'Blueprint Brainstorm', 
    questlineId: 'rube-goldberg', 
    prerequisiteQuestId: 1300, 
    description: 'You\'ve got your goal. Now, let\'s sketch a rough plan for your machine in your Invention Log.', 
    details: 'Find your Invention Log and pick your favourite final task. In your unlined notebook, draw a big, wild blueprint for your machine. Don\'t worry about reality yet! This plan can change later. For now, just draw a path from start to finish with lots of cool steps.' 
  },
  { 
    id: 1302, 
    category: QuestCategory.Explorer, 
    title: 'The Inventor\'s Box', 
    questlineId: 'rube-goldberg', 
    prerequisiteQuestId: 1301, 
    description: 'An inventor needs materials. Go on a scavenger hunt to create your official "Inventor\'s Box".', 
    details: 'Your machine will be built from everyday objects. Find a shoebox and start your collection. Look for things that roll (marbles), things that fall (dominoes), things that swing (string), and things for ramps (cardboard tubes). This box will be your toolkit for the whole project.' 
  },
  { 
    id: 1303, 
    category: QuestCategory.Creator, 
    title: 'Module 1: The Domino Effect', 
    questlineId: 'rube-goldberg', 
    prerequisiteQuestId: 1302, 
    description: 'Let\'s build the first piece of your contraption. Create a reliable domino chain reaction that you can use later.', 
    details: 'Get out your Inventor\'s Box. Your mission is to build a standalone chain reaction with at least 10 dominoes (or books). Test it and tweak it until it works perfectly 3 times in a row. When you\'re done, you can put the parts back in the box. You have created your first reusable module.',
    youtubeId: 'DEvj2Elpo-4'
  },
  { 
    id: 1304, 
    category: QuestCategory.Creator, 
    title: 'Module 2: Ramp & Roll', 
    questlineId: 'rube-goldberg', 
    prerequisiteQuestId: 1303, 
    description: 'Time to add a new module to your collection. Your quest is to build and perfect a reliable ramp system.', 
    details: 'Using your Inventor\'s Box, build a series of ramps. Your goal is to make a ball roll down them and hit a specific, marked target at the end. Just like last time, test it until it works 3 times in a row. You now have two modules ready to be connected.',
    youtubeId: 'i-gG2SgA5vY'
  },
  { 
    id: 1305, 
    category: QuestCategory.Creator, 
    title: 'Module 3: The Connection', 
    questlineId: 'rube-goldberg', 
    prerequisiteQuestId: 1304, 
    description: 'You have two modules. Now, let\'s be an engineer and connect them together.', 
    details: 'Set up your domino run (Module 1) so that the last domino hits the ball for your ramp system (Module 2). Your quest is to get this two-part machine to work successfully. You might need to adjust the positioning many times. This is what engineering is all about!',
    youtubeId: 'lueq_Cm5H9c'
  },
  {
    id: 1306,
    category: QuestCategory.SkillBuilder,
    title: 'The Troubleshooter',
    questlineId: 'rube-goldberg',
    prerequisiteQuestId: 1305,
    description: 'Your machine is getting complex. It\'s time to learn the most important engineering skill: troubleshooting.',
    details: 'Re-assemble your machine so far. Run it. Where does it fail most often? Your quest is to identify one "failure point" and make one specific improvement to fix it. In your Invention Log, write down the problem and the solution you engineered.'
  },
  {
    id: 1307,
    category: QuestCategory.TeamUp,
    title: 'The Grand Finale',
    questlineId: 'rube-goldberg',
    prerequisiteQuestId: 1306,
    description: 'Your incredible contraption is nearly ready. It\'s time to connect everything and film a successful run.',
    details: 'Assemble all the machine parts you\'ve built. Add a final step to achieve the goal from your Invention Log. Ask a family member to be your camera operator. Your job is to set up and start the machine. Their job is to film the entire chain reaction. It might take many tries!',
    youtubeId: "qyb5A1J2AxE"
  },
  {
    id: 1308,
    category: QuestCategory.TeamUp,
    title: 'World Premiere',
    questlineId: 'rube-goldberg',
    prerequisiteQuestId: 1307,
    description: 'You did it! You\'re an inventor! It\'s time to show your masterpiece to the world (or at least, the family).',
    details: 'Host a "World Premiere" for your family. Show them the video of your incredible contraption in action. Talk them through the different parts you built and which bit was the trickiest. Be proud of what you created!'
  }
];